// Özel boyut yönetimi saf mantığı (TODO-KPI-146 / K-B4): düzenleme formu ↔ PATCH gövdesi (yalnız
// değişen alanlar) ve sunucu hatası → kullanıcı metni. Bileşen BreakdownDimensionsPanel yalnız
// görünüm + olay.

import {
  normalizeMappingLabel,
  type KpiBreakdownCustomDimension,
  type KpiBreakdownCustomDimensionPatch,
  type KpiRootCode,
} from "@mahir/shared";
import { ApiError } from "../api/client";
import { breakdownErrorText, KPI_BREAKDOWN_COPY } from "./kpi-breakdown-copy";

export interface DimensionEditForm {
  label: string;
  /** her satır bir üye */
  membersText: string;
  categories: KpiRootCode[];
}

export function formFromDimension(
  d: Pick<KpiBreakdownCustomDimension, "label" | "members" | "categories">,
): DimensionEditForm {
  return { label: d.label, membersText: d.members.join("\n"), categories: [...d.categories] };
}

/** Satırlardan üye listesi: kırpılır, boşlar atılır, normalize hâli aynı olanlar tekilleşir. */
export function membersFromText(text: string): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const line of text.split(/\r?\n/)) {
    const label = line.trim();
    if (label === "") continue;
    const key = normalizeMappingLabel(label) || label;
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(label);
  }
  return out;
}

const sameList = (a: readonly string[], b: readonly string[]): boolean =>
  a.length === b.length && a.every((x, i) => x === b[i]);

/** Değişen alanlar; hiçbiri değişmediyse ya da ad boşsa null (kaydet pasif). */
export function patchFromForm(
  original: Pick<KpiBreakdownCustomDimension, "label" | "members" | "categories">,
  form: DimensionEditForm,
): KpiBreakdownCustomDimensionPatch | null {
  const label = form.label.trim();
  if (label === "") return null;
  const members = membersFromText(form.membersText);
  const patch: KpiBreakdownCustomDimensionPatch = {};
  if (label !== original.label) patch.label = label;
  if (!sameList(members, original.members)) patch.members = members;
  const cats = [...form.categories].sort();
  if (!sameList(cats, [...original.categories].sort())) patch.categories = form.categories;
  return Object.keys(patch).length > 0 ? patch : null;
}

/** Sunucu hatası → metin (kullanımda: grup sayısı; hazır boyut; diğerleri genel tablo). */
export function dimensionManageError(err: unknown): string {
  const C = KPI_BREAKDOWN_COPY.dimensions;
  if (err instanceof ApiError) {
    if (err.code === "breakdown_dimension_in_use") {
      const groups = (err.details as { groups?: unknown } | null | undefined)?.groups;
      return typeof groups === "number" ? C.inUse(groups) : err.message;
    }
    if (err.code === "breakdown_dimension_preset") return C.presetLocked;
    return breakdownErrorText(err.code, err.message);
  }
  return C.failed;
}
